"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeSplit = typeSplit;
exports.getTypeDef = getTypeDef;
exports.getTypeClass = getTypeClass;
exports.createClass = createClass;
exports.default = createType;
exports.TypeDefInfo = void 0;

var _util = require("@plugnet/util");

var _EnumType = _interopRequireDefault(require("./EnumType"));

var _Compact = _interopRequireDefault(require("./Compact"));

var _Option = _interopRequireDefault(require("./Option"));

var _Struct = _interopRequireDefault(require("./Struct"));

var _Tuple = _interopRequireDefault(require("./Tuple"));

var _Vector = _interopRequireDefault(require("./Vector"));

var _typeRegistry = _interopRequireDefault(require("./typeRegistry"));

var _Linkage = require("./Linkage");

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
let TypeDefInfo;
exports.TypeDefInfo = TypeDefInfo;

(function (TypeDefInfo) {
  TypeDefInfo[TypeDefInfo["Compact"] = 0] = "Compact";
  TypeDefInfo[TypeDefInfo["Enum"] = 1] = "Enum";
  TypeDefInfo[TypeDefInfo["Option"] = 2] = "Option";
  TypeDefInfo[TypeDefInfo["Plain"] = 3] = "Plain";
  TypeDefInfo[TypeDefInfo["Struct"] = 4] = "Struct";
  TypeDefInfo[TypeDefInfo["Tuple"] = 5] = "Tuple";
  TypeDefInfo[TypeDefInfo["Vector"] = 6] = "Vector";
  TypeDefInfo[TypeDefInfo["Linkage"] = 7] = "Linkage";
})(TypeDefInfo || (exports.TypeDefInfo = TypeDefInfo = {}));

// safely split a string on ', ' while taking care of any nested occurences
function typeSplit(type) {
  let sDepth = 0;
  let tDepth = 0;
  let vDepth = 0;
  let start = 0;
  const result = [];

  for (let index = 0; index < type.length; index++) {
    switch (type[index]) {
      case ',':
        // we are not nested, add the type
        if (sDepth === 0 && tDepth === 0 && vDepth === 0) {
          result.push(type.substr(start, index - start).trim());
          start = index + 1;
        }

        break;
      // inc struct depth, start found

      case '{':
        sDepth++;
        break;
      // dec struct depth, end found

      case '}':
        sDepth--;
        break;
      // inc tuple depth, start found

      case '(':
        tDepth++;
        break;
      // dec tuple depth, end found

      case ')':
        tDepth--;
        break;
      // inc compact/vec depth, start found

      case '<':
        vDepth++;
        break;
      // dec compact/vec depth, end found

      case '>':
        vDepth--;
        break;
      // normal character

      default:
        break;
    }
  }

  (0, _util.assert)(!sDepth && !tDepth && !vDepth, "Invalid defintion (missing terminators) found in ".concat(type)); // the final leg of the journey

  result.push(type.substr(start, type.length - start).trim());
  return result;
}

function getTypeDef(_type, name) {
  const type = _type.toString().trim();

  const value = {
    info: TypeDefInfo.Plain,
    name,
    type
  };
  let subType = '';

  const startingWith = (type, start, end) => {
    if (type.substr(0, start.length) !== start) {
      return false;
    }

    (0, _util.assert)(type[type.length - 1] === end, "Expected '".concat(start, "' closing with '").concat(end, "'"));
    subType = type.substr(start.length, type.length - start.length - 1);
    return true;
  };

  if (startingWith(type, '(', ')')) {
    value.info = TypeDefInfo.Tuple;
    value.sub = typeSplit(subType).map(inner => getTypeDef(inner));
  } else if (startingWith(type, '{', '}')) {
    const parsed = JSON.parse(type);
    const keys = Object.keys(parsed);

    if (keys.length === 1 && keys[0] === '_enum') {
      const details = parsed[keys[0]]; // not as pretty, but remain compatible with oo7 for both struct and Array types

      value.sub = Array.isArray(details) ? details.map(name => ({
        info: TypeDefInfo.Plain,
        name,
        type: 'Null'
      })) : Object.keys(details).map(name => ({
        info: TypeDefInfo.Plain,
        name,
        type: details[name] || 'Null'
      }));
      value.info = TypeDefInfo.Enum;
    } else {
      value.info = TypeDefInfo.Struct;
      value.sub = keys.map(name => getTypeDef(parsed[name], name));
    }
  } else if (startingWith(type, 'Compact<', '>')) {
    value.info = TypeDefInfo.Compact;
    value.sub = getTypeDef(subType);
  } else if (startingWith(type, 'Option<', '>')) {
    value.info = TypeDefInfo.Option;
    value.sub = getTypeDef(subType);
  } else if (startingWith(type, 'Vec<', '>')) {
    value.info = TypeDefInfo.Vector;
    value.sub = getTypeDef(subType);
  } else if (startingWith(type, 'Linkage<', '>')) {
    value.info = TypeDefInfo.Linkage;
    value.sub = getTypeDef(subType);
  }

  return value;
} // Returns the type Class for construction


function getTypeClass(value) {
  const Type = (0, _typeRegistry.default)().get(value.type);

  if (Type) {
    return Type;
  }

  switch (value.info) {
    case TypeDefInfo.Compact:
      (0, _util.assert)(value.sub && !Array.isArray(value.sub), 'Expected subtype for Compact');
      return _Compact.default.with(getTypeClass(value.sub));

    case TypeDefInfo.Enum:
      (0, _util.assert)(value.sub && Array.isArray(value.sub), 'Expected subtype for Enum');
      return _EnumType.default.with(value.sub.reduce((result, sub, index) => {
        result[sub.name] = getTypeClass(sub);
        return result;
      }, {}));

    case TypeDefInfo.Option:
      (0, _util.assert)(value.sub && !Array.isArray(value.sub), 'Expected subtype for Option');
      return _Option.default.with(getTypeClass(value.sub));

    case TypeDefInfo.Struct:
      (0, _util.assert)(Array.isArray(value.sub), 'Expected nested subtypes for Struct');
      return _Struct.default.with(value.sub.reduce((result, sub) => {
        result[sub.name] = getTypeClass(sub);
        return result;
      }, {}));

    case TypeDefInfo.Tuple:
      (0, _util.assert)(Array.isArray(value.sub), 'Expected nested subtypes for Tuple');
      return _Tuple.default.with(value.sub.map(getTypeClass));

    case TypeDefInfo.Vector:
      (0, _util.assert)(value.sub && !Array.isArray(value.sub), 'Expected subtype for Vector');
      return _Vector.default.with(getTypeClass(value.sub));

    case TypeDefInfo.Linkage:
      (0, _util.assert)(value.sub && !Array.isArray(value.sub), 'Expected subtype for Linkage');
      return _Linkage.Linkage.withKey(getTypeClass(value.sub));
  }

  throw new Error("Unable to determine type from '".concat(value.type, "'"));
}

function createClass(type) {
  return getTypeClass(getTypeDef(type));
}

function createType(type, value) {
  // l.debug(() => ['createType', { type, value }]);
  const Type = createClass(type);
  return new Type(value);
}